/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react'
import moment from 'moment';
import { sortByKey, totalMealValue } from 'lib/services';
import LazyLoad from 'react-image-lazy-load';
import Popover from 'react-simple-popover';
import ReactHtmlParser from 'react-html-parser';
import { fraction } from 'mathjs';
import { PlusIcon, SubIcon } from '../recipeList/RecipeData'
import { DeletePopup } from  './RecipeForWeekCalendar'


class WeekRecipeData extends Component {
  constructor(props){
    super(props);
    const vRData = this.props.vRData || { }
    this.state = {
      ...props,
      dayDates: props.dayDates || [],
      mealArr: props.mealArr || [],
      cookDay: props.cookDay || [],
      cookDayColorArr:["#00C853","#6236FF","#FA6400","#32C5FF","#F7B500","#B620E0","#979797"],
      showRcpIndex: [],
      height: 70,
      rSelIndex: -1,
      rId: -1,
      bundleSel: 0,
      notesArr: props.notesArr || [],
      cookIndex: -1,
      showRecipePopup: false,
      popupIndex: -1,
      clickInstructionAccordion: vRData.clickInstructionAccordion || false,
      clickIngredientAccordion: vRData.clickIngredientAccordion || false,
      showInstructions: vRData.showInstructions || false,
      showIngredients: vRData.showIngredients || false,
      colorIndex: -1,
      showDelete: false,
      showEdit: false,
      message: "",
      updatedServing: props.defaultServingSize,
      showBundleIndex: []
    }
  }

  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(props) {
    const vRData = props.vRData || { }
    const { showEdit } = this.state
    this.setState({...props })
    if(vRData && vRData.popupIndex !== undefined){
      
      this.setState({ 
        // servingSize: props.defaultServingSize, 
        showRecipePopup: vRData.showRecipePopup || false,
        popupIndex: vRData.popupIndex ,
        clickInstructionAccordion: vRData.clickInstructionAccordion || false,
        clickIngredientAccordion: vRData.clickIngredientAccordion || false,
        showInstructions: vRData.showInstructions || false,
        showIngredients: vRData.showIngredients || false,
        recipeData: vRData.recipeData || {},
      })
    }
    if(vRData && vRData.servSize !== undefined){
      
      this.setState({ updatedServing: vRData.servSize })
    }
    if(vRData && vRData.colorIndex !== undefined){
      this.setState({ colorIndex: vRData.colorIndex, cookIndex: vRData.cookIndex })
    }
    if(sessionStorage.getItem('height')) {
      this.setState({ height:74, rSelIndex: -1, cookIndex:-1, rId:-1, showRcpIndex: []})
      sessionStorage.removeItem('height')
    }
    if(props.textMessage && showEdit) {
      // const updatedServing = vRData.updatedServing  ? vRData.updatedServing : vRData.recipeData.servingSize
      this.setState({ message:"Servings Updated"})
      setTimeout(()=>this.setState({ message:"", showEdit: false}), 1000)
    }
    

  }
  

  setServing(size,action){
    const { 
      popupIndex, recipeData, clickInstructionAccordion, clickIngredientAccordion,
      showInstructions, showIngredients 
    } = this.state
    const rData = {
      showRecipePopup:true ,
      popupIndex,
      clickInstructionAccordion,
      clickIngredientAccordion,
      showInstructions,
      showIngredients,
      recipeData,
    }
    if(action === "add") {
      this.props.addServing(popupIndex, size, rData)
    } else {
      this.props.removeServing(popupIndex, size, rData)
    }
  }

  setHeight(showRcpIndex, showBundleIndex) {
    let bundle = 0
    let preBundle = 0
    let meal = 0
    let premeal = 0
    let preHeight = []
    let preExpandBundle = 0
    this.state.cookDay.map((item, cIndex)=>{
      if(item.recipe.length > 0) {
        bundle = 0
        meal = 0
        preBundle = 0
        preExpandBundle = 0
        // alert(cIndex)
        item.recipe.map((rcp, rcIndex)=>{
          if(rcp.isBundle && showRcpIndex.length > 0 && cIndex === showRcpIndex[0].index) {
            bundle += 1
            if(showBundleIndex.findIndex(x=>x.id === `${cIndex}${rcIndex}`) > -1) {
              preExpandBundle +=1
            }
          } else if(showRcpIndex.length > 0 && cIndex === showRcpIndex[0].index) {
            // alert('yes')
            meal +=1
          }
          // if(cIndex === 0) {
          preBundle = bundle
          premeal = meal
          // }
          return rcp;
        })
        const addBundle = preExpandBundle > 0 ? preExpandBundle * 60 : 0 
        const hei = (preBundle * 70)+(premeal*60) + addBundle + 65
        preHeight.push({height:`${hei}`})
      }
      return item;
    }) 
    preHeight = preHeight.sort(sortByKey('height','asc'))
    const hData = preHeight[0] ? parseInt(preHeight[0].height,0) : 70
    return hData > 70 ? hData : 70 
  }
	
  mealRcp(mealIndex, rcpIndex, dayIndex) {
    const { 
      mealArr, cookDayColorArr, rId, cookIndex, showRecipePopup, popupIndex, recipeIds, 
      showIngredients, showInstructions, colorIndex, bundleSel, showBundleIndex, cookDay
    } = this.state

    if(showRecipePopup && popupIndex !== -1) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }
    
    const position = dayIndex < 4 ? 'right' : 'left'
    
    let topMargin = window.scrollY < 80 ? mealIndex === 0 ? "20px" :"-20px" :  `50px`  
    topMargin = showIngredients || showInstructions ?  "0px" :  topMargin  
    
    const margin = position === 'right' ? `${topMargin} 12px` : `${topMargin} 0 0px -8px`
       
    const sideClass = mealArr[mealIndex].recipe[rcpIndex].sideName ? 'sidenm half-wdt' : 'sidenm full-wdt' 
    const cookClass = mealArr[mealIndex].recipe[rcpIndex].sideName ? 'meal-cook-day with-side' : 'meal-cook-day without-side'
    
    let style = rId === mealArr[mealIndex].recipe[rcpIndex].recipe_id && mealArr[mealIndex].recipe[rcpIndex].cookIndex != null ? 
      { border: `3px solid ${cookDayColorArr[cookIndex]}`, borderRadius: '4px'} : null
    if(popupIndex !== -1) {
      const rindex = popupIndex.split('type')
      const selRcp = rId === mealArr[mealIndex].recipe[rcpIndex].recipe_id
      const color = colorIndex !==null && colorIndex !== -1 ? cookIndex=== -1 || !selRcp  ? cookDayColorArr[colorIndex] : cookDayColorArr[cookIndex] : '#979797' 
      style = mealArr[rindex[0]].recipe[rindex[1]] && mealArr[rindex[0]].recipe[rindex[1]].id === mealArr[mealIndex].recipe[rcpIndex].id ? { border: `3px solid ${color}`, borderRadius: '4px'} : style
    }
    if(bundleSel) {
      const index = showBundleIndex.findIndex(x=>x.rId === rId)
      if(index > -1) {
        const cookRIndex = showBundleIndex[index].cookIndex
        const reIndex = cookDay[cookRIndex].recipe.findIndex(x=>x.recipe_id === rId)
        if(reIndex > -1 && cookDay[cookIndex].recipe[reIndex].isBundle ){
          style = cookDay[cookIndex].recipe[reIndex].bundleRecipe.findIndex(x=>x.id === mealArr[mealIndex].recipe[rcpIndex].recipe_id) > -1 && mealArr[mealIndex].recipe[rcpIndex].cookIndex != null ? 
            { border: `3px solid ${cookDayColorArr[cookIndex]}`, borderRadius: '4px'} : null
        }

      }
      console.log(showBundleIndex, index)
    }
    
  
    const containerStyle = { borderRadius: '8px',background:'#fff', padding: 0, zIndex:'99', 	boxShadow: '0 11px 15px -7px rgba(0,0,0,0.2), 0 9px 46px 8px rgba(0,0,0,0.12), 0 24px 38px 3px rgba(0,0,0,0.14)', margin,}
    const rIndex = `${[mealIndex]}type${rcpIndex}`                   
    let popstyle = {padding:'0', width:'360px',float:'left',  boxShadow:'none', background:'transparent', display:'block', zIndex: '99'}
    popstyle = showIngredients || showInstructions ? 
      {padding:'0', width:'380px', float:'left',  zIndex:'99',boxShadow:'rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px', background:'#fff', display:'block', top:'100px',position:'fixed'}
      : popstyle
    return(
      <div 
        className={`meal-rcp ${mealArr[mealIndex].recipe[rcpIndex]}`} 
        style={style}
        ref={`meal-rcp ${mealIndex}${[rcpIndex]}`}
        onClick={()=>{this.showRecipe(mealArr[mealIndex].recipe[rcpIndex].recipeData, true, rIndex, mealArr[mealIndex].recipe[rcpIndex].cookIndex)}}
      >
        <span>
          <LazyLoad
            loaderImage
            originalSrc={mealArr[mealIndex].recipe[rcpIndex].image}
            offsetLeft={window.innerWidth}
            offsetHorizontal={360}
            height={85}
            imageProps={{
              src: '/images/small.png',
              draggable: false,
              name: 'd.',
            }}
            className='recipe_img'
                                    
          />
        </span>
        
        <Popover
          placement={position}
          container={document.body}
          hideWithOutsideClick={false}
          // eslint-disable-next-line react/no-string-refs
          target={this.refs[`meal-rcp ${mealIndex}${rcpIndex}`]}
          show={showRecipePopup && rIndex === popupIndex}
          style={popstyle}
          containerStyle={containerStyle}
          onHide={()=>this.handleClose()} >
          {
            showRecipePopup && rIndex === popupIndex &&
            this.quickView(mealArr[mealIndex].recipe[rcpIndex].meal_date, 
              recipeIds, mealArr[mealIndex].recipe[rcpIndex].recipe_id, 
              mealArr[mealIndex].recipe[rcpIndex].sideRcp, mealArr[mealIndex].recipe[rcpIndex].id)
          }
        </Popover>
        <div className="meal-rcp-nm">
          <h5>{mealArr[mealIndex].recipe[rcpIndex].name}</h5>
          <span className="rcp-info">
            { mealArr[mealIndex].recipe[rcpIndex].sideName && 
              <span className={sideClass}> {mealArr[mealIndex].recipe[rcpIndex].sideName} </span>
            }
            {mealArr[mealIndex].recipe[rcpIndex].cookDay && 
              <span className={cookClass} style={{ color: cookDayColorArr[mealArr[mealIndex].recipe[rcpIndex].cookIndex] }}>
                {mealArr[mealIndex].recipe[rcpIndex].cookDay}
              </span>
            }
          </span>
        </div>
      </div>
    )
  }

  clickRecipe(event,index,cIndex,rId, rcpBundle) {
    event.stopPropagation();
    const { rSelIndex, showBundleIndex, showRcpIndex } = this.state
    let bunIndex = -1
    
    if(rcpBundle === 1){
      let { height } = this.state
      bunIndex = showBundleIndex.findIndex(x=>x.id=== `${index}${cIndex}`)
      if(bunIndex === -1) {
        showBundleIndex.push({id:`${index}${cIndex}`, cookIndex: index, rId })
        height = this.setHeight(showRcpIndex, showBundleIndex)
        this.setState({ height})
      }
    }
    if(rSelIndex !== `${index}${cIndex}`)
      this.setState({rSelIndex: `${index}${cIndex}`, rId, cookIndex: index, showBundleIndex, bundleSel:rcpBundle})
    else {
      let { height } = this.state
      if(bunIndex > -1) {
        showBundleIndex.splice(bunIndex,1)
        // const totalBundle = totalMealValue(showBundleIndex,'cookIndex',index)
        // if(height > ((showRcpIndex[0].length*52) +75+(totalBundle*70)))
        //   height -= 65
        height = this.setHeight(showRcpIndex, showBundleIndex)
      }
      this.setState({ rSelIndex: -1, rId: -1, cookIndex:-1, height, bundleSel:0 })
    }
  }

  cookMealRecipe(index) {
    const { cookDay, rSelIndex, cookDayColorArr, showBundleIndex  } = this.state
    return(
      <div className="cook-sch" key={index}>
        {
          cookDay[index].recipe.map((item, cIndex)=>{
            const style = rSelIndex === `${index}${cIndex}` ? { border: `2px solid ${cookDayColorArr[index]}`, borderRadius: '4px' } :
              { borderTop: '1.5px solid #D8D8D8'}
            const name = item.isBundle === 0 ? item.name : `Bundle: ${item.name}`
            const showBundle = showBundleIndex.findIndex(x=>x.id === `${index}${cIndex}`) > - 1 
            return(
            
              <div key={`${cookDay[index].cooking_day}${cIndex}`}>
                <div key={cIndex} className="cook-rcp-data" style={style} onClick={(event)=>this.clickRecipe(event,index,cIndex,item.recipe_id, item.isBundle)}>
                  <h4>{name}</h4>
                  <div className="rcp-tmp">
                    {item.equipmentIcon !=null && <span><img src={item.equipmentIcon} alt="icn"/> </span>}
                    <span>{item.activeTime} Active</span>
                    <span> <i className="fa fa-circle"/> </span>
                    <span>{item.totalTime} Total</span>
                  </div>
                  {
                    item.isBundle === 1 && showBundle &&
                    <div className="subRecipe">
                      <ul>
                        {
                          item.bundleRecipe.map(rcp=>
                            (
                              <li key={rcp.id}> {rcp.name} </li> 
                            )
                          )
                        }
                      </ul>
                    </div>
                  }
                </div>
              </div>	
            )}
          )
        }
      </div>
    )
  }

  expandData(event,cookIndex) {
    event.stopPropagation()
    const { cookDay, showBundleIndex } = this.state
    let { height, showRcpIndex } = this.state
    const index = showRcpIndex.findIndex(x=> x.index===cookIndex)
    if(index > -1) {
      showRcpIndex.splice(index,1)
      showBundleIndex.map((bunData,bunIndex)=>{
        if(bunData.cookIndex === cookIndex) {
          showBundleIndex.splice(bunIndex,1)
        }
        return null
      })
      height = this.setHeight(showRcpIndex, showBundleIndex)
      
    } else {
      showRcpIndex.push({index:cookIndex, length: `${cookDay[cookIndex].recipe.length}`})
    }
    showRcpIndex = showRcpIndex.sort(sortByKey('length','desc'))
    height = this.setHeight(showRcpIndex, showBundleIndex)
    this.setState({ showRcpIndex, height, rId: -1, rSelIndex: -1 })
  }

	
  cookSchdule() {
    const { dayDates, cookDay, height, showRcpIndex, cookDayColorArr } = this.state
    const tDate = moment().format('DD-MM-YYYY')
    let colorIndex = -1
    
    return(
      dayDates.map((day, index)=>{
        let cDateClass = "bold-cDate"
        let dayClass = ""
        const activeDate = `${day.date}-${day.Month}-${day.Year}`
        const dayDate = `${day.Year}-${day.Month}-${day.date}`
        const cookIndex = cookDay.findIndex(x=>x.cooking_date === dayDate )
        if(activeDate === tDate) {
          cDateClass = "bold-cDate active"
          dayClass = "active"
        } 
        colorIndex = cookIndex > -1 ? colorIndex + 1 : colorIndex
        const brdrClass = index === 0 ? "no-brdr" : ""
        const totalMeal = cookIndex > -1 ? totalMealValue(cookDay[cookIndex].recipe,'isBundle',0) : 0
        const bundleLength = cookIndex > -1 && cookDay[cookIndex].recipe.length - totalMeal
        const rcpText = totalMeal > 1 ? 'Recipes' : 'Recipe'
        const bundleText = cookIndex > -1 && bundleLength > 1 ? 'Bundles' : 'Bundle'
        return(
          <div className="day-range" key={activeDate}>
            <span className={dayClass}>{day.day}</span>
            <span className={`cDate-cls ${brdrClass}`}>
              <span className={cDateClass}>{day.date}</span>
            </span>
            <div className={`cook-sch-cls ${brdrClass}`} style={{ height: `${height}px`}} onClick={(event)=>this.clickRecipe(event)}>
              { index === 0 && <span className="side-rcp-hdng">prep schedule</span> }
              {
                cookIndex > -1 &&
                <div className="cookMealRcp">
                  <span className="headr-brd mb-hide" style={{borderLeft: `4px solid ${cookDayColorArr[cookIndex]}`}}/>
                  { cookDay[cookIndex].recipe.length > 0 &&
                    <div className="cook-sch-rcp">
                      <h4> {cookDay[cookIndex].totalHands} Active </h4>
                      <div className="meal-typ">
                        <span>
                          { bundleLength > 0 && <span> {bundleLength} {bundleText} </span>}
                          {totalMeal > 0 && bundleLength > 0 && <span> <i className="fa fa-circle"/> </span>}
                          {totalMeal > 0 && <span> {totalMeal} {rcpText} </span>}
                        </span>
                        {showRcpIndex.findIndex(x=>x.index === cookIndex) === -1  ?
                          <span onClick={(event)=> this.expandData(event,cookIndex)} className="expand"> Show <i className="fa fa-angle-down" /> </span>
                          :
                          <span onClick={(event)=> this.expandData(event,cookIndex)} className="expand"> Collapse <i className="fa fa-angle-up" /> </span>
                        }
                      </div>
                    </div>
                  } 
                  {showRcpIndex.findIndex(x=>x.index === cookIndex) > -1  && this.cookMealRecipe(cookIndex)}
                </div>
              }
            </div>
          </div>
        )
      })
    )
  }

  addNote() {
    const { dayDates, notesArr } = this.state
    return(
      <div className="rcp-typ notes">
        {
          dayDates.map(day=>{
            const dayDate = `${day.Year}-${day.Month}-${day.date}`
            const noteIndex = notesArr.length > 0 ?  notesArr.findIndex(x=>x.date === dayDate ) : -1
            
            const noteContent = noteIndex > -1 ? notesArr[noteIndex].content : null
            return(
              <div key={`${day.Month}-${day.date}`} className="day-range">
                <button className="add-notes">
                  {noteIndex === -1?
                    <span className="notes-section add" onClick={()=>this.props.showNotes(dayDate, 'add', null, -1)}>
                      <i className="fa fa-pencil"/>
                      <span> Add a Note </span>
                    </span>
                    :  
                    <span className="notes-section" onClick={()=>this.props.showNotes(dayDate, 'edit', notesArr[noteIndex], -1)}>
                      <span className="add-notes"><b>Notes:</b> {noteContent} </span>
                    </span>
                  }
                </button>
              </div>
            )
          })
        }
      </div>
    )
  }


  quickView(cDate, recipeIds, rId, sideRcp, rPos) {
    const { 
      recipeData, clickInstructionAccordion, showInstructions, showEdit,
      clickIngredientAccordion, showIngredients, updatedServing, message
    } = this.state
    const equipmentIcn = recipeData.items.recipe.equipmentIcon
    let sideName = ""
    const type = recipeData.isBundle === 0 ? 'meal' : 'mealbundle'
    const index = recipeIds.findIndex(x=>x.id === rId && x.type === type)
    const totalServing = index > -1 ? recipeIds[index].size : 0
    if(recipeData.recipe_sides) {
      sideName = recipeData.recipe_sides.name
    }
    
    const serveText = recipeData.servingSize > 1 ? 'servings' : 'serving'
    const image = recipeData.items.recipe.recipeImage
    
    return(
      <div className="recipe-popover">
        {this.actionButton(recipeData, sideName, totalServing,cDate, rPos)}
        <div className="rcp-img">
          <img src={image} alt="" />
        </div>
        <div className="rcp-quk-detail">
          <div className="rcp-row rcp-header">
            <div className="rcp-icn"> <img src={equipmentIcn}  alt="euiqpment"/> </div>
            <div className="rcp-nm">
              <h2 onClick={()=>this.viewRecipe(recipeData,recipeData.items.recipe.name, sideName, totalServing )}>{recipeData.items.recipe.name}</h2>
              {sideName !=="" && <p className="side">{sideName}</p>}
            </div>
          </div>
          <div className={!clickIngredientAccordion ? "rcp-row dtil" : "rcp-row dtil active"}>
            <div className="rcp-icn"> <img src="/images/ingredients.svg"  alt="euiqpment"/> </div>
            <div className="rcp-nm">
              <p  onClick={()=> this.clickAccordion('ingredients')}>Ingredients
                { !clickIngredientAccordion ?
                  <i className="fa fa-angle-down" />
                  :
                  <i className="fa fa-angle-up" />
                }
              </p>
            </div>
          </div>
          <div className={`showlist${showIngredients} servInfo`}>
            <p className="serving-info">
              Ingredient quantities shown for this meal only ({updatedServing}).&nbsp;
              <span onClick={()=>this.viewRecipe(recipeData,recipeData.items.recipe.name, sideName, totalServing )}>View </span> 
              details to see ingredients for all servings on this meal plan
            </p>
          </div>
          <div key='ingredients' className={`showlist${showIngredients}`}>
            { recipeData.items.recipe.recipeIngredient.length > 0 &&
                recipeData.items.recipe.recipeIngredient.map((value) => {
                  let quantity = value.quantity;
                  quantity *= (updatedServing / 4);
                  
                  let a = 0;
                  quantity = quantity.toString().split('.');
                  quantity[0] = parseInt(quantity[0], 0);
                  
                  if (quantity[0] === 0) {
                    quantity[0] = '';
                  }
                  if (quantity.length > 1 && quantity[1] !== '00') {
                    quantity[1] = `${0}.${quantity[1]}`;
                    a = fraction(parseFloat(quantity[1]));
                  
                    if (a.d > 0 && a.n > 3) {
                      a.d = Math.floor(a.d / a.n);
                      a.n = 1;
                    }
                  }
                  if (a !== 0 && a.d > 1) {
                    a = ReactHtmlParser(`${quantity[0]}<sup>${a.n}</sup>&frasl;<sub>${a.d}</sub>`);
                  } else if (a !== 0 && a.d < 1) {
                    a = a.n;
                  } else {
                    a = quantity[0];
                  }
                  
                  return (
                    <ul key={value.ingredient.name}>
                      <li key={value.id}>
                        {a} {value.unit} {value.ingredient.name }
                      </li>
                    </ul>
                  );
                })
            }
          </div>
            
          <div className={!clickInstructionAccordion ? "rcp-row dtil" : "rcp-row dtil active"}>
            <div className="rcp-icn"> 
              <i className="fa fa-list-ol" />
            </div>
            <div className="rcp-nm">
              <p  onClick={()=> this.clickAccordion('instructions')}> Directions
                { !clickInstructionAccordion ?
                  <i className="fa fa-angle-down" />
                  :
                  <i className="fa fa-angle-up" />
                }
              </p>
            </div>
          </div>
          <div className={`instructions showlist${showInstructions}`}>
            <ol>
              { recipeData.items.recipe.recipeInstruction.length > 0 &&
                  recipeData.items.recipe.recipeInstruction.map(value => (
                    <li key={value.id}>
                      {ReactHtmlParser(value.instruction) }
                    </li>
                  ))
              }
            </ol>
          </div>
          <div className="rcp-row tim">
            <div className="rcp-icn"> <img src="/images/time.svg"  alt="euiqpment"/> </div>
            <div className="rcp-nm">
              <p>{recipeData.totalHands} Hands On</p>
              <span>{recipeData.totalTime} Total Cook Time</span>
            </div>
          </div>
        </div>
        <div className="rcp-servng-detail">
          <div className="servng-meal">
            <h3>Meal {serveText} :&nbsp; 
              {showEdit ?
                <ul className="set-serving">		
                  <li>
                    <a className="mb-hide red-circle" onClick={()=>this.setServing(recipeData.servingSize, 'sub')}>
                      <SubIcon />
                    </a>
                  </li>
                
                  <li> {recipeData.servingSize} </li>
                
                  <li>
                    <a className="mb-hide Green-circle" onClick={()=>this.setServing(recipeData.servingSize, 'add')}>
                      <PlusIcon />
                    </a>
                  </li>
                </ul>
                : 
                recipeData.servingSize
              }
            </h3>
            <span>Total for this week : {totalServing} </span>
          </div>
          <div className="edt-section">
            { !showEdit  ?
              <button className="edit" onClick={()=>this.showEdit()}>Edit</button>
              :
              message === "" ?
                <button className="save" onClick={()=>this.saveServing()}> Save </button>
                :
                <span className="colr">{message}</span>
            }
          </div>
        </div>
      </div>
    )
  }

  saveServing() {
    const { 
      recipeData, popupIndex, showIngredients, showInstructions, 
      clickIngredientAccordion, clickInstructionAccordion, updatedServing, mealArr
    } = this.state
    let sideDishId = ""
    if(recipeData.recipe_sides ) {
      sideDishId = recipeData.recipe_sides.sideId
    }
    const rindex = popupIndex.split('type')
    const params = {
      update_meal_schedule:[{
        id:mealArr[rindex[0]].recipe[rindex[1]].id,
        recipe_id: mealArr[rindex[0]].recipe[rindex[1]].recipe_id,
        side_dish_id: sideDishId,
        serving_size: mealArr[rindex[0]].recipe[rindex[1]].recipeData.servingSize,
        isBundle: mealArr[rindex[0]].recipe[rindex[1]].recipeData.isBundle
      }],
    }
    this.setState({ updatedServing: recipeData.servingSize})
    const rData = {
      showRecipePopup:true ,
      popupIndex,
      clickInstructionAccordion,
      clickIngredientAccordion,
      showInstructions,
      showIngredients,
      recipeData,
      updatedServing
    }
    this.props.editServing(params,  rData)
  }

  showEdit() {
    const { showEdit } = this.state
    this.setState({ showEdit: !showEdit})
  }

  // view recipe detail function
  viewRecipe(recipe, rname, sname, totalServing) {
    const { 
      popupIndex, showRecipePopup, clickInstructionAccordion, cookIndex,colorIndex,
      clickIngredientAccordion, showInstructions, showIngredients, updatedServing
    } = this.state
    
    const rData = {
      showRecipePopup,
      popupIndex,
      clickInstructionAccordion,
      clickIngredientAccordion,
      showInstructions,
      showIngredients,
      recipeData: recipe,
      servSize: updatedServing,
      cookIndex,
      colorIndex,
    }
    this.props.viewRecipe(recipe, rname, sname, totalServing, rData)
  }

  swapRecipe(recipe,popupIndex){
    const { 
      showRecipePopup, clickInstructionAccordion, cookIndex,colorIndex,
      clickIngredientAccordion, showInstructions, showIngredients, updatedServing
    } = this.state
    const rData = {
      showRecipePopup,
      popupIndex,
      clickInstructionAccordion,
      clickIngredientAccordion,
      showInstructions,
      showIngredients,
      recipeData: recipe,
      servSize: updatedServing,
      cookIndex,
      colorIndex,
    }
    this.props.swapRecipe(rData)
  }

  deleteRecipe(recipeData,rPos) {
    this.setState({ showDelete: true, showRecipePopup: false, recipeData, recipeIndex:rPos})
  }

  actionButton(recipeData, sideName, totalServing,cDate, rPos) {
    const { popupIndex } = this.state
    return(
      <div className="action-btn">
        <div className="lft-view-btn" onClick={()=>this.viewRecipe(recipeData,recipeData.items.recipe.name, sideName, totalServing )}>
          <img src="/images/eye.svg" alt="" />
          <span>View</span>
        </div>
        <div className="rgt-btn">
          {recipeData.isBundle === 0 &&<div className="round-brdr" title="Swap" onClick={()=>this.swapRecipe(recipeData,popupIndex)}><img src="/images/swapbtn.svg" alt="" /></div>}
          <div className="round-brdr" title="Delete recipe" onClick={()=>this.deleteRecipe(recipeData, rPos)}><img src="/images/del.svg" alt="" /></div>
          <div className="round-brdr" title="Close" onClick={()=>this.closePopup()}><img src="/images/clos.svg" alt="" className="cross" /></div>
        </div>
      </div>
    )
  }

  closePopup() {
    const { showIngredients, showInstructions, clickIngredientAccordion, clickInstructionAccordion } = this.state
    const rData = {
      popupIndex:-1,
      showIngredients, showInstructions, clickIngredientAccordion, clickInstructionAccordion
    }
    this.setState({ showEdit: false, colorIndex:-1 })
    this.props.closePopup(rData)
  }

  cancelDelete() {
    this.setState({ showDelete: false,  showRecipePopup: true})
  }

  confirmDelete(index, id, recipeId) {
    this.setState({ showDelete: false, showRecipePopup: false, popupIndex:-1})
    this.props.deleteRecipe(index, id, recipeId)
  }

  handleClose() {
    const { showRecipePopup } = this.state
    if(showRecipePopup)
      this.setState({ showRecipePopup: false, popupIndex: -1})
  }

  showRecipe(recipe, showRecipePopup,rIndex, colorIndex){
    const { rId } = this.state
    if(rId !== recipe.items.recipe.id ){
      this.setState({ cookIndex: -1, rId:-1, rSelIndex:-1 })
    }
    if(this.state.popupIndex === -1){
      const rData = { 
        recipeData: recipe, showRecipePopup, popupIndex: rIndex,
        showIngredients: false, showInstructions: false, clickIngredientAccordion: false, clickInstructionAccordion: false
      }
      this.setState({ colorIndex,recipeData: recipe, showRecipePopup: true, popupIndex: rIndex, 
        showDelete: false, updatedServing: recipe.servingSize, 
      })  
      this.props.closePopup(rData)
    }
  }

  clickAccordion(value){
    const { clickAccordion } = this.state
    let { showIngredients, showInstructions, showNutrition, clickIngredientAccordion, clickInstructionAccordion, clickNutritionAccordion } = this.state;
    if(value === 'ingredients') {
      showIngredients = !showIngredients
      clickIngredientAccordion = !clickIngredientAccordion
    } else if(value === 'instructions') {
      showInstructions = !showInstructions
      clickInstructionAccordion = !clickInstructionAccordion
    } else if(value === 'nutrition') {
      showNutrition = !showNutrition
      clickNutritionAccordion = !clickNutritionAccordion
    }
    this.setState({ 
      clickAccordion: !clickAccordion,
      showNutrition,
      showIngredients,
      showInstructions,
      clickIngredientAccordion,
      clickInstructionAccordion,
      clickNutritionAccordion,
    });
  }

  render() {
    const { dayDates, mealArr, showDelete, popupIndex, recipeData, recipeIndex } = this.state
    return (
      <div className="vw-slc-rcp">
        <div className="rcp-cal">
          {
            dayDates.length > 0 &&
					this.cookSchdule()
          }
        </div>
        <div className="rcp-cal">
          {
            dayDates.length > 0 &&
					mealArr.map((item, mealIndex)=>
					  <div className="rcp-typ" key={item.type}>
					    {
					      dayDates.map((day, index)=>{
					        const activeDate = `${day.date}-${day.Month}-${day.Year}` 
					        const brdrClass = index === 0 ? "no-brdr": ""
					        const dayDate = `${day.Year}-${day.Month}-${day.date}`
					        const rcpIndex = item.recipe.findIndex(x=>x.meal_date === dayDate )

					        return(
					          <div className="day-range" key={activeDate}>
										 
					            <div className={`cook-sch-cls typ-rcp ${brdrClass}`}>
					                { index === 0 && <div><span className="side-rcp-hdng"> {item.type} </span> </div>}
					              <div className="typ-rcp">
					                { rcpIndex === -1 ?
					                  <div className="add-hr-btn">
					                    <button className="cook-day" onClick={()=>this.props.buildPlan(dayDates,'addSingle')}>
					                      <img src="/images/add-small.svg" alt=""/>
					                      <span> Recipe </span>
					                    </button>
					                  </div>
					                  :
					                  this.mealRcp(mealIndex, rcpIndex, index)
					                }
					              </div>
					            </div>
					          </div>
					        )
					      }
					      )
					    }
					  </div>
					)
          }   
          { dayDates.length>0 && this.addNote()}
          {
            showDelete && 
            <div>
              <DeletePopup 
                cancelDelete={(recipe,index)=>this.cancelDelete(recipe,true,index)}
                deleteRecipe={(index, id, recipeId)=>this.confirmDelete(index, id, recipeId)}
                recipeData={recipeData}
                popupIndex={popupIndex}
                recipeIndex={recipeIndex}
              />
              <div className="modal-backdrop fade in " />
            </div>
          }
        </div>
      </div>
    )
  }
}
export default WeekRecipeData


// WEBPACK FOOTER //
// ./src/components/dashboard/WeekRecipeData.js